import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const PCContentRoutes = [{
  path: '/',
  component: () =>
            import('./views/PC/Layout'),
  redirect: '/home',
  children: [{
    path: '/home',
    show: true,
    label: '首页',
    icon: 'icon-huodong',
    component: () =>
                    import('./views/PC/Home')
  },
  {
    path: '/case',
    component: () =>
                    import('./views/PC/Case'),
    children: [{
      path: '/case/umcc',
      component: () =>
                            import('./views/PC/Case/components/CaseUmcc')
    },
    {
      path: '/case/mettler',
      component: () =>
                            import('./views/PC/Case/components/CaseMettler')
    },
    {
      path: '/case/tax',
      component: () =>
                            import('./views/PC/Case/components/CaseTax')
    },
    {
      path: '/case/kitchenAid',
      component: () =>
                            import('./views/PC/Case/components/CaseKitchenAid')
    },
    {
      path: '/case/viking',
      component: () =>
                            import('./views/PC/Case/components/CaseViking')
    },
    {
      path: '/case/gardner-denver',
      component: () =>
                            import('./views/PC/Case/components/CaseGardnerDenver')
    },
    {
      path: '/case/tektronix',
      component: () =>
                            import('./views/PC/Case/components/CaseTektronix')
    },
    {
      path: '/case/effect-evaluation',
      component: () =>
                            import('./views/PC/Case/components/CaseDidi')
    },
    {
      path: '/case/price-auditing',
      component: () =>
                            import('./views/PC/Case/components/CasePriceAuditing')
    },
    {
      path: '/case/purchasing-bayer',
      component: () =>
                            import('./views/PC/Case/components/CasePurchasingBayer')
    },
    {
      path: '/case/ad-bayer',
      component: () =>
                            import('./views/PC/Case/components/CaseAdBayer')
    }
    ]
  },
  {
    path: '/service',
    component: () =>
                    import('./views/PC/Service'),
    children: [{
      path: '/service/ad-marketing',
      component: () =>
                            import('./views/PC/Service/components/AdMarketing')
    },
    {
      path: '/service/effect-evaluation',
      component: () =>
                            import('./views/PC/Service/components/EffectEvaluation')
    },
    {
      path: '/service/price-auditing',
      component: () =>
                            import('./views/PC/Service/components/PriceAuditing')
    },
    {
      path: '/service/digital-management',
      component: () =>
                            import('./views/PC/Service/components/DigitalManagement')
    },
    {
      path: '/service/resource-purchasing',
      component: () =>
                            import('./views/PC/Service/components/ResourcePurchasing')
    },
    {
      path: '/service/financial-service',
      component: () =>
                            import('./views/PC/Service/components/FinancialService')
    }
    ]
  },
  {
    path: '/about',
    component: () =>
                    import('./views/PC/About')
  },
  {
    path: '/about-us',
    component: () =>
                    import('./views/PC/AboutUs/index.vue')
  },
  {
    path: '/product',
    component: () =>
                    import('./views/PC/Product'),
    children: [{
      path: '/product/libra',
      component: () =>
                            import('./views/PC/Product/components/Libra')
    },
    {
      path: '/product/data_hub',
      component: () =>
                            import('./views/PC/Product/components/DataHub')
    },
    // 2021年12月7日18:35:04 增加好快活
    {
      path: '/product/happy',
      component: () =>
                            import('./views/PC/Product/components/Happy')
    },
    {
      path: '/product/i_media_tracker',
      component: () =>
                            import('./views/PC/Product/components/iMediaTracker')
    },
    {
      path: '/product/i_media_matrix',
      component: () =>
                            import('./views/PC/Product/components/iMediaMatrix')
    },
    {
      path: '/product/guileme',
      component: () =>
                            import('./views/PC/Product/components/Guileme')
    },
    {
      path: '/product/bid_agent',
      component: () =>
                            import('./views/PC/Product/components/BidAgent')
    },
    {
      path: '/product/rimix',
      component: () =>
                            import('./views/PC/Product/components/Rimix')
    }
    ]
  }
  ]
},
{
  path: '/contact',
  component: () =>
            import('./views/PC/Contact')
}
]

const MobileContentRoutes = [{
  path: '/',
  component: () =>
            import('./views/Mobile/Layout'),
  redirect: '/home',
  children: [{
    path: '/home',
    show: true,
    label: '首页',
    icon: 'icon-huodong',
    component: () =>
                    import('./views/Mobile/Home')
  },
  {
    path: '/case',
    component: () =>
                    import('./views/Mobile/Case'),
    children: [{
      path: '/case/umcc',
      component: () =>
                            import('./views/Mobile/Case/components/CaseUmcc')
    },
    {
      path: '/case/mettler',
      component: () =>
                            import('./views/Mobile/Case/components/CaseMettler')
    },
    {
      path: '/case/tax',
      component: () =>
                            import('./views/Mobile/Case/components/CaseTax')
    },
    {
      path: '/case/kitchenAid',
      component: () =>
                            import('./views/Mobile/Case/components/CaseKitchenAid')
    },
    {
      path: '/case/viking',
      component: () =>
                            import('./views/Mobile/Case/components/CaseViking')
    },
    {
      path: '/case/gardner-denver',
      component: () =>
                            import('./views/Mobile/Case/components/CaseGardnerDenver')
    },
    {
      path: '/case/tektronix',
      component: () =>
                            import('./views/Mobile/Case/components/CaseTektronix')
    },
    {
      path: '/case/effect-evaluation',
      component: () =>
                            import('./views/Mobile/Case/components/CaseDidi')
    },
    {
      path: '/case/price-auditing',
      component: () =>
                            import('./views/Mobile/Case/components/CasePriceAuditing')
    },
    {
      path: '/case/purchasing-bayer',
      component: () =>
                            import('./views/Mobile/Case/components/CasePurchasingBayer')
    },
    {
      path: '/case/ad-bayer',
      component: () =>
                            import('./views/Mobile/Case/components/CaseAdBayer')
    }
    ]
  },
  {
    path: '/service',
    component: () =>
                    import('./views/Mobile/Service'),
    children: [{
      path: '/service/ad-marketing',
      component: () =>
                            import('./views/Mobile/Service/components/AdMarketing')
    },
    {
      path: '/service/effect-evaluation',
      component: () =>
                            import('./views/Mobile/Service/components/EffectEvaluation')
    },
    {
      path: '/service/price-auditing',
      component: () =>
                            import('./views/Mobile/Service/components/PriceAuditing')
    },
    {
      path: '/service/digital-management',
      component: () =>
                            import('./views/Mobile/Service/components/DigitalManagement')
    },
    {
      path: '/service/resource-purchasing',
      component: () =>
                            import('./views/Mobile/Service/components/ResourcePurchasing')
    },
    {
      path: '/service/financial-service',
      component: () =>
                            import('./views/Mobile/Service/components/FinancialService')
    }
    ]
  },
  {
    path: '/about-us',
    component: () =>
                    import('./views/Mobile/AboutUs/index.vue')
  },
  {
    path: '/about',
    component: () =>
                    import('./views/Mobile/About')
  },
  {
    path: '/product',
    component: () =>
                    import('./views/Mobile/Product'),
    children: [{
      path: '/product/rimix',
      component: () =>
                            import('./views/Mobile/Product/components/Rimix')
    },
    {
      path: '/product/data_hub',
      component: () =>
                            import('./views/Mobile/Product/components/DataHub')
    },
    //2022-3-7 15:51:16
    {
      path: '/product/happy',
      component: () =>
                            import('./views/Mobile/Product/components/Happy')
    },
    {
      path: '/product/i_media_tracker',
      component: () =>
                            import('./views/Mobile/Product/components/iMediaTracker')
    },
    {
      path: '/product/i_media_matrix',
      component: () =>
                            import('./views/Mobile/Product/components/iMediaMatrix')
    },
    {
      path: '/product/guileme',
      component: () =>
                            import('./views/Mobile/Product/components/Guileme')
    },
    {
      path: '/product/bid_agent',
      component: () =>
                            import('./views/Mobile/Product/components/BidAgent')
    },
    {
      path: '/product/libra',
      component: () =>
                            import('./views/Mobile/Product/components/Libra')
    }
    ]
  }
  ]
},
{
  path: '/contact',
  component: () =>
            import('./views/Mobile/Contact')
}
]

const TabletContentRoutes = [{
  path: '/',
  component: () =>
            import('./views/Mobile/Layout'),
  redirect: '/home',
  children: [{
    path: '/home',
    show: true,
    label: '首页',
    icon: 'icon-huodong',
    component: () =>
                    import('./views/Tablet/Home')
  },
  {
    path: '/case',
    component: () =>
                    import('./views/Mobile/Case'),
    children: [{
      path: '/case/umcc',
      component: () =>
                            import('./views/Mobile/Case/components/CaseUmcc')
    },
    {
      path: '/case/mettler',
      component: () =>
                            import('./views/Mobile/Case/components/CaseMettler')
    },
    {
      path: '/case/tax',
      component: () =>
                            import('./views/Mobile/Case/components/CaseTax')
    },
    {
      path: '/case/kitchenAid',
      component: () =>
                            import('./views/Mobile/Case/components/CaseKitchenAid')
    },
    {
      path: '/case/viking',
      component: () =>
                            import('./views/Mobile/Case/components/CaseViking')
    },
    {
      path: '/case/gardner-denver',
      component: () =>
                            import('./views/Mobile/Case/components/CaseGardnerDenver')
    },
    {
      path: '/case/tektronix',
      component: () =>
                            import('./views/Mobile/Case/components/CaseTektronix')
    },
    {
      path: '/case/effect-evaluation',
      component: () =>
                            import('./views/Mobile/Case/components/CaseDidi')
    },
    {
      path: '/case/price-auditing',
      component: () =>
                            import('./views/Mobile/Case/components/CasePriceAuditing')
    },
    {
      path: '/case/purchasing-bayer',
      component: () =>
                            import('./views/Mobile/Case/components/CasePurchasingBayer')
    },
    {
      path: '/case/ad-bayer',
      component: () =>
                            import('./views/Mobile/Case/components/CaseAdBayer')
    }
    ]
  },
  {
    path: '/service',
    component: () =>
                    import('./views/Mobile/Service'),
    children: [{
      path: '/service/ad-marketing',
      component: () =>
                            import('./views/Mobile/Service/components/AdMarketing')
    },
    {
      path: '/service/effect-evaluation',
      component: () =>
                            import('./views/Mobile/Service/components/EffectEvaluation')
    },
    {
      path: '/service/price-auditing',
      component: () =>
                            import('./views/Mobile/Service/components/PriceAuditing')
    },
    {
      path: '/service/digital-management',
      component: () =>
                            import('./views/Mobile/Service/components/DigitalManagement')
    },
    {
      path: '/service/resource-purchasing',
      component: () =>
                            import('./views/Mobile/Service/components/ResourcePurchasing')
    },
    {
      path: '/service/financial-service',
      component: () =>
                            import('./views/Mobile/Service/components/FinancialService')
    }
    ]
  },
  {
    path: '/about',
    component: () =>
                    import('./views/Mobile/About')
  },
  {
    path: '/product',
    component: () =>
                    import('./views/Mobile/Product'),
    children: [{
      path: '/product/rimix',
      component: () =>
                            import('./views/Mobile/Product/components/Rimix')
    },
    {
      path: '/product/data_hub',
      component: () =>
                            import('./views/Mobile/Product/components/DataHub')
    },
    {
      path: '/product/i_media_tracker',
      component: () =>
                            import('./views/Mobile/Product/components/iMediaTracker')
    },
    {
      path: '/product/i_media_matrix',
      component: () =>
                            import('./views/Mobile/Product/components/iMediaMatrix')
    },
    {
      path: '/product/guileme',
      component: () =>
                            import('./views/Mobile/Product/components/Guileme')
    },
    {
      path: '/product/bid_agent',
      component: () =>
                            import('./views/Mobile/Product/components/BidAgent')
    },
    {
      path: '/product/libra',
      component: () =>
                            import('./views/Mobile/Product/components/Libra')
    }
    ]
  }
  ]
},
{
  path: '/contact',
  component: () =>
            import('./views/Mobile/Contact')
}
]

const contentRoutes = () => {
  let device = 'mobile'
  let contentRoutes = []
  var ua = navigator.userAgent
  var isWindowsPhone = /(?:Windows Phone)/.test(ua)
  var isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
  var isAndroid = /(?:Android)/.test(ua)
  var isFireFox = /(?:Firefox)/.test(ua)
  var isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
  var isiPhone = /(?:iPhone)/.test(ua) && !isTablet
  var isPc = !isiPhone && !isAndroid && !isSymbian && !isTablet
  if (isPc) {
    device = 'pc'
    contentRoutes = PCContentRoutes
  } else if (isTablet) {
    device = 'tablet'
    contentRoutes = TabletContentRoutes
  } else if (isiPhone || isAndroid || isSymbian) {
    contentRoutes = MobileContentRoutes
  }
  window.$device = device
  Vue.prototype.$device = device
  return contentRoutes
}

const router = new Router({
  mode: 'history',
  routes: contentRoutes()
})

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
  // 百度统计代码添加
  setTimeout(() => {
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?49a4dd6a64145f1e4c87bbf845c41126'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }, 0)
  const element = document.querySelectorAll('.el-message--error')
  Array.prototype.forEach.call(element, node => {
    node.parentNode.removeChild(node)
  })
})

export default router
